/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Asset
 */
export interface AssetDto {
  fullName: string;
  code: string;
  /**
   * Max supported decimals after dot for quantity fields.
   */
  scale: number;
  /**
   * Referral USD cost.
   */
  usdRefCost: number;
  /**
   * True if asset is fiat one.
   */
  fiat: boolean;
}
